import React, { useEffect, useState, useContext } from 'react';
import { Formik, Form } from 'formik';

import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { SelectReverseByID, Reverse } from 'Components/Api/OverdraftApi';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import InputLabel from 'Components/Inputes/InputLabel';
import { Container, Grid, Button } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import {
    PLEASE_PROVIDE_VALID,
    MESSAGE_CLOSE_AFTER
} from 'Components/Helper/Messages';
import { BalanceContext } from 'Components/BalanceContext';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const ReverseAction = ({ OverdraftMasterID, onDismissCallback }) => {
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const classes = commonStyle();

    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [formObject, setFormObject] = useState({
        OverdraftMasterID: 0,
        Wallet: '',
        OverdraftAmount: 0,
        DOC: '',
        Sender: '',
        WalletBalance: 0,
        AdminRemark: '',
        Amount: 0
    });

    const validationSchema = Yup.object({
        AdminRemark: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'sender remark'
        ),
        OverdraftMasterID: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'ID')
            .min(1, PLEASE_PROVIDE_VALID + 'ID')
    });

    const select = async (OverdraftMasterID) => {
        let primaryID = OverdraftMasterID;
        let JSONObj = {
            OverdraftMasterID: primaryID
        };
        setLoadingOpen(true);
        var request = JSON.stringify(JSONObj);

        const response = await SelectReverseByID(request);
        setLoadingOpen(false);

        if (!response.isAuthorized) {
            LOGOUT();
        }

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        var data = JSON.parse(response.data);

        setFormObject({
            OverdraftMasterID: data.OverdraftMasterID,
            OverdraftAmount: data.Amount,
            DOC: data.DOC,
            Wallet: data.Wallet,
            Sender: data.User,
            WalletBalance: data.WalletBalance,
            AdminRemark: '',
            InWords: NumberToWord(data.Amount),
            Amount: data.Amount
        });
    };

    useEffect(() => {
        select(OverdraftMasterID);
    }, []);

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setLoadingOpen(true);

        setResponseMessage('');
        setIsError(false);

        var response = await Reverse(JSON.stringify(values));

        if (!response.isAuthorized) LOGOUT();

        DashboardBalanceUpdate();
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setLoadingOpen(false);
            return;
        }
        setSubmitting(false);

        resetForm(formObject);
        setTimeout(() => {
            onDismissCallback(false);
        }, MESSAGE_CLOSE_AFTER);
    };
    const OnAmountChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) return;

        setFieldValue('InWords', NumberToWord(value));
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <Grid container spacing={3}>
                                <Grid item xs={4}>
                                    <MaterialTextField
                                        label="Date"
                                        name="DOC"
                                        type="text"
                                        readOnly={true}
                                        title="DOC"
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <MaterialTextField
                                        label="Wallet"
                                        name="Wallet"
                                        type="text"
                                        readOnly={true}
                                        title="Wallet"
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <MaterialCurrency
                                        name="WalletBalance"
                                        label="Wallet Balance"
                                        readOnly={true}
                                        placeholder="WalletBalance"
                                        autoComplete="new-password"
                                        max={1000000}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <MaterialCurrency
                                        name="OverdraftAmount"
                                        label="Overdraft Amount"
                                        readOnly={true}
                                        placeholder="OverdraftAmount"
                                        autoComplete="new-password"
                                        max={1000000}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <MaterialTextField
                                        label="Sender"
                                        name="Sender"
                                        type="text"
                                        readOnly={true}
                                        title="Sender"
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={4}>
                                    <MaterialCurrency
                                        name="Amount"
                                        label="Amount"
                                        placeholder="Amount"
                                        autoComplete="new-password"
                                        max={9999999}
                                        onCustomCallback={(value) => {
                                            OnAmountChange(
                                                value,
                                                setFieldValue
                                            );
                                        }}
                                    />
                                    <InputLabel
                                        color="green"
                                        value={values.InWords}
                                    />
                                </Grid>

                                <Grid item xs={8}>
                                    <MaterialTextField
                                        label="Admin Remark"
                                        name="AdminRemark"
                                        type="text"
                                        title="Admin Remark"
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Box display="none">
                                        <MaterialTextField
                                            label="OverdraftMasterID"
                                            name="OverdraftMasterID"
                                            type="text"
                                            title="OverdraftMasterID"
                                        />
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid
                                className={classes.footerGrid}
                                style={{ marginTop: '20px' }}
                            >
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Submit"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loadingOpen}
                                        >
                                            Submit
                                        </Button>
                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
